import { createBaseFormatterFactory } from './baseUtils.js';
/**
 * Format a number as binary.
 *
 * Syntax:
 *
 *    math.bin(value)
 *
 * Examples:
 *
 *    //the following outputs "0b10"
 *    math.bin(2)
 *
 * See also:
 *
 *    oct
 *    hex
 *
 * @param {number} value    Value to be stringified
 * @return {string}         The formatted value
 */

export var createBin = createBaseFormatterFactory('bin', 2);


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/function/string/bin.js
// module id = null
// module chunks = 